import { XbotMessageSuggestion } from "@dto/pyxbot-agent.dto";
import { FC } from "react";

/** The three next questions. Three is the sketch's number; anything past it is noise under a card. */
export const SUGGEST_LIMIT = 3;

/** The next questions an answer suggests, as the whole sentences a click sends. */
export function suggestionItems(suggestions: XbotMessageSuggestion[] | null | undefined): string[] {
  return (suggestions || []).map((row) => (row?.text || "").trim()).filter(Boolean).slice(0, SUGGEST_LIMIT);
}

// Clickable full sentences, not tokens — a click sends exactly what typing it would have. Without onPick (an older
// turn is read, not re-answered) the sentences stay and the clicks go quiet.
export const SuggestRow: FC<{
  suggestions: XbotMessageSuggestion[] | null | undefined;
  onPick?: (sentence: string) => void;
}> = ({ suggestions, onPick }) => {
  const sentences = suggestionItems(suggestions);
  if (!sentences.length) {
    return null;
  }
  return <div className="xm-chat-suggests" role="group" aria-label="Ask next">
    {sentences.map((sentence, index) => (onPick
      ? <button key={index} type="button" className="xm-chat-suggest" onClick={() => onPick(sentence)}>{sentence}</button>
      : <span key={index} className="xm-chat-suggest xm-chat-suggest-quiet">{sentence}</span>))}
  </div>;
};
